import React, {
  // useCallback,
  useEffect,
 useMemo,
} from 'react';
import loginSrc from 'assets/Login.png';
// import { useAuthContext } from 'AuthContext';
import PropTypes from 'prop-types';
import Empty from 'components/Empty';
import { Button, Typography } from '@mui/material';
import { useAuthContext } from '../AuthContext';

const NotAuthorized = ({ message = '' }) => {
  const { showSignInDialog } = useAuthContext();
  useEffect(
    () => {
      if (!message) {
        showSignInDialog();
      }
    },
    [showSignInDialog, message],
  );
  return (
    <Empty
      icon={useMemo(
        () => (
          <img
            src={loginSrc}
            style={{
              width: 250,
              height: 250,
              color: '#F99106',
            }}
            alt='login'
          />
        ),
        [],
      )}
      style={useMemo(
        () => ({
          height: '100vh',
          justifyContent: 'center',
        }),
        [],
      )}
      title={message ? <Typography variant=''>{message}</Typography> : <Typography>Please <Button variant='contained' style={{ textTransform: 'initial' }} onClick={showSignInDialog}>Sign In</Button> to view this page!</Typography>}
    />
  );
};

NotAuthorized.propTypes = {
  message: PropTypes.string,
};

export default NotAuthorized;
